export default __webpack_public_path__ + "static/media/etherscan.3cd32578.svg";